import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "ion-text-center",
  slot: "content"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    class: "outer-card",
    style: {"margin":"0 1px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_accordion_group, { value: "Sharing" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_accordion, {
            style: {"--min-height":"24px"},
            value: "Sharing"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                lines: "none",
                slot: "header",
                style: {"--min-height":"24px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("b", null, "QR code sharing", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_ion_accordion_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "full",
                          slot: "header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createElementVNode("p", null, [
                                  _createElementVNode("b", null, "with my colleagues/students")
                                ], -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_list, {
                          class: "ion-text-center",
                          slot: "content"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, [
                              _createElementVNode("img", {
                                style: {"width":"300px"},
                                src: $setup.getQRCodeUrl(`https://ab.fdmt.hk/r/${$setup.user.schoolId}`)
                              }, null, 8, _hoisted_2)
                            ]),
                            _createElementVNode("p", null, [
                              _createTextVNode(" ab.fdmt.hk/r/" + _toDisplayString($setup.user.schoolId), 1),
                              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                color: "success",
                                size: "small",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.copyText(`https://ab.fdmt.hk/r/${$setup.user.schoolId}`)))
                              }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createElementVNode("small", null, "Copy Link", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_ion_button, {
                              size: "small",
                              color: "success",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.sendLinkToMyWhatsApp(`https://ab.fdmt.hk/r/${$setup.user.schoolId}`, $setup.user.phone, $setup.user.waGroupId)))
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode(" Send to my WhatsApp ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "full",
                          slot: "header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("p", null, [
                                  _createElementVNode("b", null, "with other schools")
                                ], -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_list, {
                          class: "ion-text-center",
                          slot: "content"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, [
                              _createElementVNode("img", {
                                style: {"width":"300px"},
                                src: $setup.getQRCodeUrl(`https://ab.fdmt.hk/r`)
                              }, null, 8, _hoisted_3)
                            ]),
                            _createElementVNode("p", null, [
                              _cache[11] || (_cache[11] = _createTextVNode(" ab.fdmt.hk/r")),
                              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                color: "success",
                                size: "small",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.copyText(`https://ab.fdmt.hk/r`)))
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createElementVNode("small", null, "Copy Link", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_ion_button, {
                              size: "small",
                              color: "success",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.sendLinkToMyWhatsApp(`https://ab.fdmt.hk/r`, $setup.user.phone, $setup.user.waGroupId)))
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode(" Send to my WhatsApp ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}